
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 20","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 0H2C.897 0 0 .897 0 2v17a1 1 0 001 1h14a1 1 0 001-1V2c0-1.103-.897-2-2-2zm0 18H2V2h12v16z"}}),_c('path',{attrs:{"d":"M4 4h3v2H4V4zm5 0h3v2H9V4zM4 8h3v2H4V8zm5 .031h3V10H9V8.031zM4 12h3v2H4v-2zm5 0h3v2H9v-2z"}})])
          )
        }
      }
    